import { memo, useEffect, useState } from 'react';
import PipelineApprovalBannerAsync from './common/components/PipelineApprovalBannerAsync';
import TaskQueueBarRendererAsync from './TaskQueueBarRendererAsync';
import { useQueryParams } from '../../router/useQueryParams';
import { delayUntilIdle } from '../utils/delayUntilIdle';
import PropTypeBanner from '../components/shared/PropTypeBanner';
import { getI18nProvider } from 'quartz-core/framework/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TopFullWidth = /*#__PURE__*/memo(({
  objectType,
  subjectId
}) => {
  const [isAsyncComponentsRendered, setIsAsyncComponentsRendered] = useState(false);
  const {
    taskId
  } = useQueryParams();
  useEffect(() => {
    delayUntilIdle(() => setIsAsyncComponentsRendered(true));
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PropTypeBanner, {}), (isAsyncComponentsRendered || taskId) && /*#__PURE__*/_jsx(TaskQueueBarRendererAsync, {
      i18nProvider: getI18nProvider(),
      subjectObjectType: objectType,
      subjectId: subjectId
    }, "GenericTaskQueueBarContainer"), isAsyncComponentsRendered && /*#__PURE__*/_jsx(PipelineApprovalBannerAsync, {})]
  });
});
TopFullWidth.displayName = 'TopFullWidth';
export default TopFullWidth;